import type { PdfBriefingConfig } from "../scenario/types";
import { tx } from "../lib/tx";

/** Shared full-viewport PDF reader used by both simulated desktops. */
export function PdfBriefing({ cfg, onClose }: { cfg: PdfBriefingConfig; onClose: () => void }) {
  return (
    <div className="pdfview" role="dialog" aria-label={cfg.title}>
      <div className="pdfview-panel">
        <div className="pdfview-titlebar">
          <span className="pdfview-ico" aria-hidden>{"\u{1F4C4}"}</span>
          <span className="pdfview-fname">{cfg.fileName ?? "Security_Briefing.pdf"}</span>
          <span className="pdfview-zoom">100%</span>
          <button type="button" className="pdfview-close" aria-label={tx("Close")} onClick={onClose}>{"\u2715"}</button>
        </div>
        <div className="pdfview-page">
          <div className="pdfview-hero">
            <div className="pdfview-eyebrow">{tx("SECURITY AWARENESS BRIEFING")}</div>
            <h1 className="pdfview-title">{cfg.title}</h1>
            {cfg.subtitle && <p className="pdfview-subtitle">{cfg.subtitle}</p>}
          </div>

          <div className="pdfview-idcard">
            <div className="pdfview-idcard-row">
              <span className="pdfview-idcard-k">{tx("Trusted domain")}</span>
              <span className="pdfview-idcard-v">{cfg.legitDomain}</span>
            </div>
            <div className="pdfview-idcard-row">
              <span className="pdfview-idcard-k">{tx("Trusted source")}</span>
              <span className="pdfview-idcard-v">{cfg.legitLoginUrl}</span>
            </div>
          </div>

          {cfg.sections.map((section, index) => (
            <div key={index} className="pdfview-section">
              <h2>{section.heading}</h2>
              {section.body?.split("\n\n").map((paragraph, paragraphIndex) => <p key={paragraphIndex}>{paragraph}</p>)}
              {section.bullets && (
                <ul>{section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>
              )}
            </div>
          ))}

          <div className="pdfview-redflags">
            <div className="pdfview-redflags-head"><span aria-hidden>{"\u26A0"}</span> {tx("Warning signs")}</div>
            <ul>{cfg.redFlags.map((flag) => <li key={flag}>{flag}</li>)}</ul>
          </div>
        </div>
        <div className="pdfview-footer">
          <button type="button" className="btn pdfview-btn" onClick={onClose}>
            {cfg.continueLabel ?? tx("Got it — continue")}
          </button>
        </div>
      </div>
    </div>
  );
}
